const faqHeader = document.querySelector('.faqs__header');
const faqBody = document.querySelector('.faqs__body');

const tabs = faqHeader && faqHeader.querySelectorAll('.tab');
const questions = faqBody && faqBody.querySelectorAll('.faq-list__item--question');

const handleTabClick = (e) => {
  e.preventDefault();
  if (faqBody && faqHeader) {
    const selectedHeader = faqHeader.querySelector('.tab.selected');
    const selectedBody = faqBody.querySelector('.faq-list.selected');
    if (selectedHeader) {
      selectedHeader.classList.remove('selected');
    }
    if (selectedBody) {
      selectedBody.classList.remove('selected');
    }
  }
  e.currentTarget.classList.add('selected');
  const targetCategory = e.currentTarget.getAttribute('data-category');
  if (targetCategory) {
    faqBody.querySelector(`#${targetCategory}`);
    const targetBody = faqBody.querySelector(`#${targetCategory}`);
    if (targetBody) {
      targetBody.classList.add('selected');
    }
  }
}

if (tabs) {
  tabs.forEach((tab) => {
    tab.addEventListener('click', handleTabClick);
  });
}

const handleQuestionClick = (e) => {
  e.preventDefault();
  e.currentTarget.classList.toggle('open');
}

if (questions) {
  questions.forEach((question) => {
    question.addEventListener('click', handleQuestionClick);
  });
}



// WEBPACK FOOTER //
// ./src/templates/components/frequently-asked-questions/frequently-asked-questions.js